import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  AccountBudgetHistoryMatchParams,
  accountHistoryRouteProps,
} from 'src/navigation/routeProps'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

export const selectCreditCardIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<AccountBudgetHistoryMatchParams>(
      backgroundLocation.pathname,
      accountHistoryRouteProps,
    ) as match<AccountBudgetHistoryMatchParams>
    return mtch.params.id
  },
)
